export default __webpack_public_path__ + "assets/close.2aaf.svg";